import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react";
import QRIcon from "./components/QRIcon";
import { sha256 } from "js-sha256";
import { Endpoints } from "../../../app/lib/LeanLinkService";
import * as styles from './styles.css';
import { useTranslation } from "react-i18next";

let initialTicker = 0;
let tickerInterval = 0;

export function LoginQRCodeTest(props) {
  const [qrStartToken, setQrStartToken] = useState();
  const [qrStartSecret, setQrStartSecret] = useState();
  const [serverResponseTime, setServerResponseTime] = useState();
  const [secondsDifference, setSecondsDifference] = useState(0);
  const [secondsDifferenceCET, setSecondsDifferenceCET] = useState(0);
  const [qrAuthCode, setQrAuthCode] = useState();
  const [qrAuthCodeExample0, setQrAuthCodeExample0] = useState();
  const [qrAuthCodeExample1, setQrAuthCodeExample1] = useState();
  const [qrAuthCodeExample2, setQrAuthCodeExample2] = useState();
  const [qrAuthCodeCET, setQrAuthCodeCET] = useState();

  const { t } = useTranslation();

  useEffect(() => {

    fetch(window.location.origin + '/public/bankid/auth/1').then(response => response.json()).then(data => {
      console.log('response data', data);
      console.log('qrStartToken ', data.qrStartToken);
      console.log('qrStartToken ', data.qrStartToken);
      console.log('qrStartSecret ', data.qrStartSecret);
      console.log('time ', data.time);
      setQrStartToken(data.qrStartToken)
      setQrStartSecret(data.qrStartSecret)
      setServerResponseTime(data.time)

      if (!initialTicker) {
        let now = new Date();
        var currentTimeUTC = new Date(
          now.getTime() + now.getTimezoneOffset() * 60000
        );
        var currentTimeCET = new Date(currentTimeUTC.getTime());
        currentTimeCET.setHours(currentTimeCET.getHours() + 2);

        let initTime = new Date(currentTimeCET);
        initTime.setHours(parseInt(data.time.split(":")[0]) + 2);
        initTime.setMinutes(data.time.split(":")[1]);
        initTime.setSeconds(data.time.split(":")[2]);

        let secondsDifferenceCET = 0;
        let secondsDifference = Math.abs(
          parseInt(
            (currentTimeCET.getTime() - currentTimeUTC.getTime()) / 1000
          )
        );

        if (!tickerInterval) {
          let _self = this;
          tickerInterval = setInterval(function () {
            secondsDifference++;
            secondsDifferenceCET++;


            sha256.hmac(data.qrStartToken, secondsDifference.toString());
            var hash = sha256.hmac.create(data.qrStartToken);
            hash.update(secondsDifference.toString());
            let finalHash = hash.hex();

            sha256.hmac(data.qrStartToken, secondsDifferenceCET.toString());
            var hashCET = sha256.hmac.create(data.qrStartToken);
            hashCET.update(secondsDifferenceCET.toString());
            let finalHashCET = hashCET.hex();

            setSecondsDifference(secondsDifference)
            setSecondsDifferenceCET(secondsDifferenceCET)
            setQrAuthCode(finalHash)
            setQrAuthCodeCET(finalHashCET)

            if (!qrAuthCodeExample0) {
              sha256.hmac('d28db9a7-4cde-429e-a983-359be676944c', '0');
              var hashExample0 = sha256.hmac.create('d28db9a7-4cde-429e-a983-359be676944c');
              hashExample0.update('0');
              setQrAuthCodeExample0(hashExample0.hex())
            }
            if (!qrAuthCodeExample1) {
              sha256.hmac('d28db9a7-4cde-429e-a983-359be676944c', '1');
              var hashExample1 = sha256.hmac.create('d28db9a7-4cde-429e-a983-359be676944c');
              hashExample1.update('1');
              setQrAuthCodeExample1(hashExample1.hex())
            }
            if (!qrAuthCodeExample2) {
              sha256.hmac('d28db9a7-4cde-429e-a983-359be676944c', '2');
              var hashExample2 = sha256.hmac.create('d28db9a7-4cde-429e-a983-359be676944c');
              hashExample2.update('2');
              setQrAuthCodeExample2(hashExample2.hex())
            }

          }, 1000);
        }

        initialTicker = data.time;
      }
    });
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          {qrStartToken && qrStartSecret && (
            <div className="text-center row">
              <p>{t("BankID-app Test Site")}</p>
              <p>{t("UTC Server response time")} : {serverResponseTime}</p>

              <br></br>
              <div className="text-center col-xs-4">
                <p className="col-xs-12">{t("Example QR codes from docs for timer 0 , 1 and 2")}</p>
                <div className="col-xs-12 p-2">
                  <p className={styles.qrInfoBox}>
                    {t("Seconds difference (ticker) : 0")} <br></br>
                    {t("qrAuthCode")} : {qrAuthCodeExample0} <br></br>
                    {t("qr code")} : {`bankid.67df3917-fa0d-44e5-b327-edcc928297f8.0.${qrAuthCodeExample0}`}
                  </p>
                  <QRCode value={`bankid.67df3917-fa0d-44e5-b327-edcc928297f8.0.${qrAuthCodeExample0}`} size={256} />
                </div>
                <div className="col-xs-12 p-2">
                  <p className={styles.qrInfoBox}>
                    {t("Seconds difference (ticker) : 1")} <br></br>
                    {t("qrAuthCode")} : {qrAuthCodeExample1} <br></br>
                    {t("qr code")} : {`bankid.67df3917-fa0d-44e5-b327-edcc928297f8.1.${qrAuthCodeExample1}`}
                  </p>
                  <QRCode value={`bankid.67df3917-fa0d-44e5-b327-edcc928297f8.1.${qrAuthCodeExample1}`} size={256} />
                </div>
                <div className="col-xs-12 p-2">
                  <p className={styles.qrInfoBox}>
                    {t("Seconds difference (ticker) : 2")} <br></br>
                    {t("qrAuthCode")} : {qrAuthCodeExample2} <br></br>
                    {t("qr code")} : {`bankid.67df3917-fa0d-44e5-b327-edcc928297f8.2.${qrAuthCodeExample2}`}
                  </p>
                  <QRCode value={`bankid.67df3917-fa0d-44e5-b327-edcc928297f8.2.${qrAuthCodeExample2}`} size={256} />
                </div>

              </div>
              <div className="text-center col-xs-4 p-2">
                <p className={styles.qrInfoBox}>{t("UTC server code example")}
                  {t("UTC Seconds difference (ticker)")} : {secondsDifference} <br></br>
                  {t("qrAuthCode")} : {qrAuthCode} <br></br>
                  {t("qr code")} : {`bankid.${qrStartToken}.${secondsDifference}.${qrAuthCode}`}
                </p>
                <QRCode value={`bankid.${qrStartToken}.${secondsDifference}.${qrAuthCode}`} size={256}
                />
              </div>
              <div className="text-center col-xs-4 p-2">
                <p className={styles.qrInfoBox}>{t("CET server code example")}
                  {t("CET Seconds difference (ticker)")} : {secondsDifferenceCET}<br></br>
                  {t("qrAuthCode")} : {qrAuthCodeCET} <br></br>
                  {t("qr code")} : {`bankid.${qrStartToken}.${secondsDifferenceCET}.${qrAuthCodeCET}`}
                </p>
                <QRCode value={`bankid.${qrStartToken}.${secondsDifferenceCET}.${qrAuthCodeCET}`} size={256}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};